import { FC } from 'react';
import i18next from 'i18next';

import { Container, SubTitle, TextRow, LinksRow, Anchor } from './contactText.sc';

interface Props {
  t: i18next.TFunction;
}

const ContactText: FC<Props> = ({ t }) => (
  <Container>
    <TextRow>
      <SubTitle data-translation="x.contact.right_side.upper_box.title">
        {t('x.contact.right_side.upper_box.title')}
      </SubTitle>
      <span data-translation="x.contact.right_side.upper_box.subtitle">
        {t('x.contact.right_side.upper_box.subtitle')}
      </span>
    </TextRow>
    <TextRow>
      <SubTitle data-translation="x.contact.right_side.lower_box.title">
        {t('x.contact.right_side.lower_box.title')}
      </SubTitle>
      <span data-translation="x.contact.right_side.lower_box.subtitle">
        {t('x.contact.right_side.lower_box.subtitle')}
      </span>
    </TextRow>
    <LinksRow>
      <Anchor target="_blank" href={t('x.imprint.link')}>
        <span data-translation="x.contact.right_side.links.imprint">
          {t('x.contact.right_side.links.imprint')}
        </span>
      </Anchor>
      <Anchor target="_blank" href={t('x.privacy.link')}>
        <span data-translation="x.contact.right_side.links.privacy">
          {t('x.contact.right_side.links.privacy')}
        </span>
      </Anchor>
      <span style={{ marginLeft: '3px' }} data-translation="x.contact.right_side.links.spacebetween">
        {t('x.contact.right_side.links.spacebetween')}
      </span>
      <Anchor target="_blank" href={t('x.signup.infos.tos.link')}>
        <span data-translation="x.contact.right_side.links.terms_conditions">
          {t('x.contact.right_side.links.terms_conditions')}
        </span>
      </Anchor>
    </LinksRow>
  </Container>
);

export default ContactText;
